import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminAuthToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminAuthToken')
      window.location.href = '/api/login'
    }
    return Promise.reject(error)
  }
)

export const authAPI = {
  signUp: (userData) => {
    console.log('AuthAPI: Sign up request with data:', userData)
    // Always pass admin: true for admin dashboard signups
    return api.post('/api/auth/register', { ...userData, admin: true })
  },
  signIn: (credentials) => {
    console.log('AuthAPI: Sign in request with credentials:', credentials)
    console.log('AuthAPI: Making POST request to:', api.defaults.baseURL + '/api/auth/login')
    return api.post('/api/auth/login', credentials)
  },
  signOut: (sessionToken) => api.post('/api/auth/logout', { sessionToken }),
  getProfile: () => api.get('/api/auth/profile'),
  refreshToken: () => api.post('/api/auth/refresh'),
}









